import { render } from "./OnboardingQuicktrialLayout.vue?vue&type=template&id=3b31fadf&scoped=true"
import script from "./OnboardingQuicktrialLayout.vue?vue&type=script&lang=js"
export * from "./OnboardingQuicktrialLayout.vue?vue&type=script&lang=js"

import "./OnboardingQuicktrialLayout.vue?vue&type=style&index=0&id=3b31fadf&lang=scss&scoped=true"
import "./OnboardingQuicktrialLayout.vue?vue&type=style&index=1&id=3b31fadf&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b31fadf"]])

export default __exports__